import React, { Component } from 'react';

class Help extends Component
{
    render ()
    {
        return (
            <div>
                Help
            </div>
        )
    }
}

export default Help;


// WEBPACK FOOTER //
// ./src/components/Help/Help.js